import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    useBreakpointValue,
    Text,
    IconButton,
    Icon
} from '@chakra-ui/react'
import {CustomClose} from '../icons'

const LeaveModal = ({isOpen, onClose, onConfirm}) => {
    const isMobile = useBreakpointValue({base: true, md: false});

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={isMobile ? 'full' : 'md'}
            motionPreset="slideInBottom"
        >
            <ModalOverlay />
            <ModalContent
                borderRadius={0}
                position={isMobile ? 'fixed' : 'relative'}
                bottom={isMobile ? '0' : 'auto'}
                m={isMobile ? '0' : 'auto'}
                padding={{base: "12px 16px 48px", lg: "16px 32px 23px"}}
                w={{base: '100%', lg: '441px'}}
                minH="228px"
            >
                <ModalHeader p={0} fontSize="lg" fontWeight="bold" mr={{lg: '-25px'}}>
                    <IconButton
                        onClick={onClose}
                        icon={<Icon as={CustomClose} />}
                        aria-label="Close modal"
                        variant="ghost"
                        size="sm"
                        background="transparent"
                        _hover={{background: 'transparent'}}
                        display="block"
                        marginLeft="auto"
                    />
                </ModalHeader>
                <ModalBody p={0}>
                    <Text
                        variant="accountStatus"
                        textTransform="uppercase"
                        mb={2}
                        mt={{base: 2, lg: '47px'}}
                        lineHeight={{base: '20px'}}
                    >
                        <FormattedMessage
                            defaultMessage="Leave without saving?"
                            id="leave_modal.title"
                        />
                    </Text>
                    <Text variant="leaveModalText" mb={{base: 4, lg: '58px'}} lineHeight={{base: '18px'}}>
                        <FormattedMessage
                            defaultMessage="Are you sure you want to go back? Any changes will be discarded."
                            id="leave_modal.message"
                        />
                    </Text>
                </ModalBody>
                <ModalFooter p={0}>
                    <Button variant="solid"
                        w="100%"
                        fontSize={{base: 'md'}}
                        lineHeight={{base: '20px'}}
                        padding={{base: '14px'}}
                        height={{base: 'auto'}}
                        onClick={onConfirm}>
                        <FormattedMessage
                            defaultMessage="Discard Changes"
                            id="leave_modal.discard"
                        />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

LeaveModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
}

export default LeaveModal
